import { render, staticRenderFns } from "./PromptLeave.vue?vue&type=template&id=1a0c72d7&"
import script from "./PromptLeave.vue?vue&type=script&lang=js&"
export * from "./PromptLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports